/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';
import { AcademicEventService } from './services/AcademicEventService';
import { AppReleaseService } from './services/AppReleaseService';
import { AuthService } from './services/AuthService';
import { ClinicBookingService } from './services/ClinicBookingService';
import { ClinicsService } from './services/ClinicsService';
import { CpdMaterialService } from './services/CpdMaterialService';
import { DashboardService } from './services/DashboardService';
import { DiaryService } from './services/DiaryService';
import { DrugAdministrationsService } from './services/DrugAdministrationsService';
import { DrugBatchesService } from './services/DrugBatchesService';
import { DrugCatalogService } from './services/DrugCatalogService';
import { DrugDestructionsService } from './services/DrugDestructionsService';
import { DrugExportService } from './services/DrugExportService';
import { DrugInventoryService } from './services/DrugInventoryService';
import { DrugRegisterAmendmentsService } from './services/DrugRegisterAmendmentsService';
import { DrugRegistersService } from './services/DrugRegistersService';
import { DrugsService } from './services/DrugsService';
import { EmergencyKitService } from './services/EmergencyKitService';
import { HealthService } from './services/HealthService';
import { IntraSedationService } from './services/IntraSedationService';
import { LibraryService } from './services/LibraryService';
import { LogService } from './services/LogService';
import { MonitorsService } from './services/MonitorsService';
import { PatientService } from './services/PatientService';
import { PatientPackService } from './services/PatientPackService';
import { ReportService } from './services/ReportService';
import { ScheduleService } from './services/ScheduleService';
import { SedationApiService } from './services/SedationApiService';
import { SedationDetailService } from './services/SedationDetailService';
import { SedationistService } from './services/SedationistService';
import { SedationMeasurementService } from './services/SedationMeasurementService';
import { SedationReportReceiptService } from './services/SedationReportReceiptService';
import { SyncService } from './services/SyncService';
import { TemplateService } from './services/TemplateService';
import { TroopOutcomeService } from './services/TroopOutcomeService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class ApiClient {
    public readonly academicEvent: AcademicEventService;
    public readonly appRelease: AppReleaseService;
    public readonly auth: AuthService;
    public readonly clinicBooking: ClinicBookingService;
    public readonly clinics: ClinicsService;
    public readonly cpdMaterial: CpdMaterialService;
    public readonly dashboard: DashboardService;
    public readonly diary: DiaryService;
    public readonly drugAdministrations: DrugAdministrationsService;
    public readonly drugBatches: DrugBatchesService;
    public readonly drugCatalog: DrugCatalogService;
    public readonly drugDestructions: DrugDestructionsService;
    public readonly drugExport: DrugExportService;
    public readonly drugInventory: DrugInventoryService;
    public readonly drugRegisterAmendments: DrugRegisterAmendmentsService;
    public readonly drugRegisters: DrugRegistersService;
    public readonly drugs: DrugsService;
    public readonly emergencyKit: EmergencyKitService;
    public readonly health: HealthService;
    public readonly intraSedation: IntraSedationService;
    public readonly library: LibraryService;
    public readonly log: LogService;
    public readonly monitors: MonitorsService;
    public readonly patient: PatientService;
    public readonly patientPack: PatientPackService;
    public readonly report: ReportService;
    public readonly schedule: ScheduleService;
    public readonly sedationApi: SedationApiService;
    public readonly sedationDetail: SedationDetailService;
    public readonly sedationist: SedationistService;
    public readonly sedationMeasurement: SedationMeasurementService;
    public readonly sedationReportReceipt: SedationReportReceiptService;
    public readonly sync: SyncService;
    public readonly template: TemplateService;
    public readonly troopOutcome: TroopOutcomeService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '1',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.academicEvent = new AcademicEventService(this.request);
        this.appRelease = new AppReleaseService(this.request);
        this.auth = new AuthService(this.request);
        this.clinicBooking = new ClinicBookingService(this.request);
        this.clinics = new ClinicsService(this.request);
        this.cpdMaterial = new CpdMaterialService(this.request);
        this.dashboard = new DashboardService(this.request);
        this.diary = new DiaryService(this.request);
        this.drugAdministrations = new DrugAdministrationsService(this.request);
        this.drugBatches = new DrugBatchesService(this.request);
        this.drugCatalog = new DrugCatalogService(this.request);
        this.drugDestructions = new DrugDestructionsService(this.request);
        this.drugExport = new DrugExportService(this.request);
        this.drugInventory = new DrugInventoryService(this.request);
        this.drugRegisterAmendments = new DrugRegisterAmendmentsService(this.request);
        this.drugRegisters = new DrugRegistersService(this.request);
        this.drugs = new DrugsService(this.request);
        this.emergencyKit = new EmergencyKitService(this.request);
        this.health = new HealthService(this.request);
        this.intraSedation = new IntraSedationService(this.request);
        this.library = new LibraryService(this.request);
        this.log = new LogService(this.request);
        this.monitors = new MonitorsService(this.request);
        this.patient = new PatientService(this.request);
        this.patientPack = new PatientPackService(this.request);
        this.report = new ReportService(this.request);
        this.schedule = new ScheduleService(this.request);
        this.sedationApi = new SedationApiService(this.request);
        this.sedationDetail = new SedationDetailService(this.request);
        this.sedationist = new SedationistService(this.request);
        this.sedationMeasurement = new SedationMeasurementService(this.request);
        this.sedationReportReceipt = new SedationReportReceiptService(this.request);
        this.sync = new SyncService(this.request);
        this.template = new TemplateService(this.request);
        this.troopOutcome = new TroopOutcomeService(this.request);
    }
}

